import { render } from "./Footer.vue?vue&type=template&id=0cf28e0b&scoped=true"
const script = {}

import "./Footer.vue?vue&type=style&index=0&id=0cf28e0b&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cf28e0b"]])

export default __exports__